export const ADD_OVERLAY = 'ADD_OVERLAY';
export const POPUP_DATA = 'POPUP_DATA';
export const CLOSE_ALL_POPUPS = 'CLOSE_ALL_POPUPS';
export const TITLE_POPUP = 'TITLE_POPUP';
export const BUTTON_POPUP = 'BUTTON_POPUP';
export const CONTENT_REVIEW = 'CONTENT_REVIEW';
